const category = 'Activity';

export const SegmentActivityEvent = {
    UNDO_CLICKED: { category, event: 'Undo clicked' },
};

export enum SegmentActivityOptions {
    TYPE = 'type'
}

export enum SegmentActivityTypeValue {
    BOARD_NAME = 'board name',
    BOARD_DESC = 'board description',
    BOARD_STATUS = 'board status',
    LIST_NAME = 'list name',
    LIST_DESC = 'list description',
    LIST_STATUS = 'list status',
    LIST_CARD_NUMBER = 'list max card number',
    CARD_NAME = 'card name',
    CARD_DESC = 'card description',
    CARD_STATUS = 'card status',
    CARD_ASSIGNEES = 'card assignees',
    CARD_START_DATE = 'card start date',
    CARD_DUE_DATE = 'card due date',
    CARD_ESTIMATE = 'card estimate',
    CARD_LIST = 'card list',
    CARD_PRIORITY = 'card priority',
    CARD_TAGS = 'card tags',
    CARD_COLOR_TAGS = 'card colour tags',
    CARD_CUSTOM = 'card custom properties',
}
